var scope_0 = require('/opt/build/repo/doc/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78d4d69753e9d1d87d69bf3aaced5b0d.js').default;
var scope_1 = require('/opt/build/repo/doc/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9fa25715b1fb853e839aa33bbf127e44.js').default;
const __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1);
export default __DOCZ_DUMMY_EXPORT_DEFAULT;
if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !Object.prototype.hasOwnProperty.call(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}
if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !Object.prototype.hasOwnProperty.call(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}